import React from "react";
import Banner from "../Banner/Banner";
import JobCategory from "../JobCategory/JobCategory";
import OnlinePortfolio from "../OnlinePortfolio/OnlinePortfolio";
import FeaturedJobs from "../FeaturedJobs/FeaturedJobs";
import Reviews from "../Reviews/Reviews";
import ReviewSlider from "../ReviewSlider/ReviewSlider";
import Testimonials from "../Testimonials/Testimonials";
import Home_Partners from "../home_Partners/Home_Partners";
import TrendingSkills from "../TrendingSkills/TrendingSkills";
import TrendingJobs from "../TrendingJobs/TrendingJobs";
import JobVacancies from "../JobVacancies/JobVacancies";
const MainHome = () => {
  
  return (
    <>
      <Banner />
      <Home_Partners/>
      <JobCategory />
      <TrendingSkills/>
      <TrendingJobs/>
      <JobVacancies/>
      {/* <OnlinePortfolio /> */}
      <FeaturedJobs />

      {/* <Reviews /> */}
      {/* <ReviewSlider /> */}
      <Testimonials />
    </>
  );
};

export default MainHome;
